var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showLoading)?_c('div',{staticClass:"wevo-loading-position"},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"white","indeterminate":""}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }